import { StaticReflector } from "@angular/compiler";

export const pravilnik_zvizdaci= {
    templateId: 220.1,
    category: 14,
    templateTitle: 'Pravilnik o postupku unutarnjeg prijavljivanja nepravilnosti i imenovanja povjerljive osobe te zamjenika povjerljive osobe',
    templateDescription: `<p>Uz ostale obveze iz Zakona o zaštiti prijavitelja nepravilnosti (tzv. "Zakon o zviždačima"; dalje u tekstu: Zakon), Poslodavac je dužan općim aktom urediti postupak unutarnjeg prijavljivanja nepravilnosti i imenovanja povjerljive osobe i zamjenika povjerljive osobe te ga učiniti dostupnim svim osobama koje obavljaju poslove.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Zakonom o zaštiti prijavitelja nepravilnosti (tzv. "Zakon o zviždačima") propisane su obveze poslodavca povodom prijavljivanja nepravilnosti.</p>
    <p>Poslodavac, u smislu spomenutog zakona je:</p>
    <li> tijelo javne vlasti,</li>
    <li> fizička ili pravna osoba (prema zakonu kojim se uređuju radni odnosi) kod koje prijavitelj nepravilnosti obavlja profesionalne aktivnosti u radnom okruženju.</li>
    <br> 
    <p>U tom smislu,<strong> poslodavac koji zapošljava najmanje 50 radnika dužan je uspostaviti sustav unutarnjeg prijavljivanja nepravilnosti, no svakako i poslodavci koji zapošljavaju manje od 50 radnika mogu imati uspostavljen sustav unutarnjeg prijavljivanja nepravilnosti.</strong></p>
    <p>Poslodavac koji je obuhvaćen primjenom akata iz dijela I. točke B. i dijela II. Priloga Zakona <strong>dužan</strong> je uspostaviti sustav unutarnjeg prijavljivanja nepravilnosti <strong>neovisno o broju zaposlenih.</strong></p>

    <p>Osim obveze donošenja općeg akta kojim se uređuje postupak unutarnjeg prijavljivanja nepravilnosti, poslodavac je dužan urediti i postupak imenovanja povjerljive osobe i njezina zamjenika (primjer odluke o imenovanju možete pogledati <a class="local-link" href="/contract?template=230.1">ovdje</a>).</p>
    
    <p>Prijavitelj nepravilnosti je fizička osoba koja prijavljuje ili javno razotkriva nepravilnosti o kojima je saznala u svom radnom okruženju.</p>
    <p>Prijava nepravilnosti može se podnijeti u pisanom ili usmenom obliku. </p>
    <p>Prijava nepravilnosti sadrži podatke o prijavitelju nepravilnosti, prijavljenom tijelu ili osobi te informacije o nepravilnostima.</p>

    <p>Nepravilnost su radnje ili propusti koji su protupravni i odnose se na područje primjene i propise navedene u Zakonu ili su u suprotnosti s ciljem ili svrhom tih propisa.</p>
    <p>Prijavitelj nepravilnosti ima pravo na:</p>
    <li>zaštitu identiteta i povjerljivosti,</li>
    <li>sudsku zaštitu, </li>
    <li>naknadu štete,</li>
    <li>primarnu besplatnu pravnu pomoć u skladu sa zakonom kojim se uređuje pravo na besplatnu pravnu pomoć,</li>
    <li>emocionalnu podršku, </li>
    <li>drugu zaštitu predviđenu u postupcima propisanim  Zakonom.</li>
    <br> 
    <p>Prijavljivanje nepravilnosti može biti:</p>
    <li> <strong>unutarnje (prijavljivanje nepravilnosti poslodavcu),</strong> </li>
    <li> vanjsko (prijavljivanje nepravilnosti nadležnom tijelu – pučkom pravobranitelju), </li>
    <li> javno razotkrivanje (otkrivanje nepravilnosti javnosti). </li>
    <br> 
    <p><strong>U smislu obveze postupanja, za poslodavca je najvažnije unutarnje prijavljivanje nepravilnosti koje ustvari predstavlja prijavljivanje nepravilnosti direktno poslodavcu.</p>
    
    <p>Poslodavac (kojega obvezuje odredbe Zakona prema prethodno navedenom), ima određene zakonske obveze, od kojih navodimo najvažnije:</strong></p>
    <li> općim aktom urediti postupak unutarnjeg prijavljivanja nepravilnosti i imenovanja povjerljive osobe i njezina zamjenika te ga na prikladan način učiniti ga dostupnim svim osobama u radnom okruženju, zajedno sa svim informacijama bitnima za podnošenje prijave nepravilnosti, </li>
    <li> uspostaviti sustav unutarnjeg prijavljivanja nepravilnosti,</li>
    <li> zaštititi prijavitelja nepravilnosti od osvete i poduzeti nužne mjere radi zaustavljanja osvete i otklanjanja njezinih posljedica,</li>
    <li> čuvati podatke zaprimljene u prijavi od neovlaštenog otkrivanja, osim ako to nije suprotno nacionalnom pravu,</li>
    <li> imenovati povjerljivu osobu za unutarnje prijavljivanje nepravilnosti i zamjenika povjerljive osobe u skladu s općim aktom (primjer navedene odluke možete pogledati <a class="local-link" href="/contract?template=230.1">ovdje</a>) </li>
    <li> osigurati uvjete za vođenje evidencije o prijavama u skladu sa zahtjevima u pogledu povjerljivosti propisanim Zakonom o zaštiti prijavitelja nepravilnosti,</li>
    <li> poduzeti mjere radi otklanjanja utvrđenih nepravilnosti,</li>
    <br> 
    <p>Također, u smislu postupanja, poslodavac ima određene Zakonom propisane obveze (ne sprječavati ili pokušavati sprječavati prijavljivanje nepravilnosti, ne otkrivati prijavitelja nepravilnosti ili prijavljene osobe, ne utjecati ili pokušati utjecati na postupanje povjerljive osobe ili njezina zamjenika i sl.).</p>
    <p>Dokument u nastavku predstavlja opći akt poslodavca kojim se uređuje postupak unutarnjeg prijavljivanja nepravilnosti te postupak imenovanja povjerljive osobe i zamjenika povjerljive osobe.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o zaštiti prijavitelja nepravilnosti.</p>
 
    `,

  sides: [
    {
        prefix: "Na temelju Zakona o zaštiti prijavitelja nepravilnosti, ",
        signature: 'Za Poslodavca',
        inputs: [{
            type: "input",
            required: true,
            placeholder: "Poslodavac",
          },
          {
            type: "input",
            required: true,
            placeholder: "Ulica i kućni broj",
          },
          {
            type: "input",
            required: true,
            placeholder: "Mjesto",
          },
          {
            type: "input",
            required: true,
            placeholder: "OIB",
          },
          {
            type: "input",
            placeholder: "Zastupa",
            inSignature: true,
          },
          {
            type: "input",
            placeholder: "Funkcija",
            inSignature: true,
          }],
        suffix: ' (u daljnjem tekstu: Poslodavac),',
    }
],

headline: '​donosi sljedeći',
title: 'PRAVILNIK O POSTUPKU UNUTARNJEG PRIJAVLJIVANJA NEPRAVILNOSTI I IMENOVANJA POVJERLJIVE OSOBE TE ZAMJENIKA POVJERLJIVE OSOBE',

articles: [
    
    {
        title: 'I. TEMELJNE ODREDBE',
        mandatory: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Ovim Pravilnikom uređuje se postupak imenovanja povjerljive osobe i zamjenika povjerljive osobe te postupak unutarnjeg prijavljivanja nepravilnosti kod Poslodavca, a sukladno odredbama Zakona o zaštiti prijavitelja nepravilnosti (u daljnjem tekstu: Zakon).',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Nepravilnost su radnje ili propusti koji su protupravni i odnose se na područje primjene i propise navedene u Zakona odnosno Prilozima Zakona ili su u suprotnosti s ciljem ili svrhom tih propisa. \r\n2) Prijavitelj nepravilnosti je fizička osoba koja prijavljuje ili javno razotkriva nepravilnosti o kojima je saznala u svom radnom okruženju.  \r\n3) Radno okruženje su profesionalne aktivnosti u javnom ili privatnom sektoru u okviru kojih, neovisno o prirodi tih aktivnosti, osobe stječu informacije o nepravilnostima i u okviru kojih bi te osobe mogle doživjeti osvetu ako prijave takve nepravilnosti, uključivši situaciju kada je aktivnost u međuvremenu prestala ili neposredno treba ili je trebala započeti, pri čemu takve aktivnosti posebno uključuju: \r\na) osobe u radnom odnosu, \r\nb) osobe koje imaju položaj samozaposlenih osoba, \r\nc) imatelje dionica i poslovnih udjela, kao i osobe koje su članovi upravnog, upravljačkog ili nadzornog tijela trgovačkog društva, uključujući neizvršne članove, te volontere i plaćene ili neplaćene vježbenike, \r\nd) osobe koje rade pod nadzorom i u skladu s uputama ugovaratelja, podugovaratelja i dobavljača, \r\ne) osobe koje na bilo koji način sudjeluju u djelatnostima pravne ili fizičke osobe \r\n4) Prijavljena osoba je tijelo javne vlasti, fizička ili pravna osoba koja je u prijavi ili pri javnom razotkrivanju nepravilnosti navedena kao odgovorna za počinjenje nepravilnosti ili s njom povezana osoba. ',
            },
        ],
    },
    {
        title: 'II. POSTUPAK IMENOVANJA POVJERLJIVE OSOBE',
        mandatory: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Povjerljivu osobu imenuje Poslodavac uz njegovu/njenu pisanu suglasnost u postupku propisanom ovim Pravilnikom. \r\n2) Povjerljiva osoba iz stavka 1. ovog članka ima zamjenika koji se imenuje na način propisan ovim Pravilnikom. \r\n3) Odredbe koje se tiču izbora, zaštite, prava i dužnosti povjerljive osobe na odgovarajući način odnose se i na zamjenika povjerljive osobe, kao i na privremeno imenovanu treću osobu. ',
            },
        ],
    },
    {
        title: '',
        mandatory: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Postupak imenovanja povjerljive osobe pokreće se objavom poziva za imenovanje povjerljive osobe i njenog zamjenika na oglasnoj ploči Poslodavca. \r\n2) Pozivom se obavještava o provedbi postupka imenovanja povjerljive osobe i zamjenika te se poziva radničko vijeće ili sindikalni povjerenik koji je preuzeo prava i obveze radničkog vijeća da u roku od 15 dana pisanim putem predlože povjerljivu osobu i zamjenika. \r\n3) U slučaju da kod Poslodavca u trenutku kada se postupak imenovanja obavlja ne bude ustanovljeno radničko vijeće kao ni sindikalni povjerenik koji je preuzeo prava i obveze radničkog vijeća pozivom će se pozvati najmanje 20% radnika da u roku od 15 dana, bilo kojim sredstvom koje omogućuje pisani zapis, predlože povjerljivu osobu i zamjenika. \r\n4) U pozivu će biti naznačeno da ukoliko radničko vijeće ili sindikalni povjerenik koji je preuzeo prava i obveze radničkog vijeća ili propisani udio od najmanje 20% radnika ne predloži povjerljivu osobu i zamjenika, da će ih Poslodavac imenovati i bez prijedloga. \r\n5) U situaciji iz stavka 3. ovog članka, ako je više osoba predloženo za povjerljivu osobu, prednost ima kandidat koji dobije potporu većeg broja radnika, a u slučaju prijedloga koji imaju jednaku podršku radnika, prednost će imati prijedlog koji je prvi zaprimljen.',
            },
        ],
    },
    {
        title: '',
        mandatory: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Odluku o imenovanju povjerljive osobe i njenog zamjenika Poslodavac donosi najkasnije u roku od 15 dana od proteka roka iz poziva (upućenom radničkom vijeću ili sindikalnom povjereniku odnosno najmanje 20% radnika). \r\n2) Prije imenovanja povjerljive osobe i zamjenika povjerljive osobe predlagatelji su dužni pribaviti njihovu pisana suglasnost. \r\n3) Odluka o imenovanju povjerljive osobe i njenog zamjenika obavezno sadrži ime i prezime povjerljive osobe i njenog zamjenika, broj telefona i adresu elektroničke pošte, a objavljuje se na oglasnoj ploči Poslodavca. \r\n4) Svaka promjena podataka iz stavka 3. ovog članka objavljuje se na oglasnoj ploči.',
            },
        ],
    },
    {
        title: 'III. POSTUPAK RAZRJEŠENJA',
        mandatory: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Ako Radničko vijeće, sindikalni povjerenik koji je preuzeo prava i obveze radničkog vijeća ili 20% zaposlenika zatraži razrješenje povjerljive osobe ili njezina zamjenika, takav prijedlog upućuje se Poslodavcu koji će donijeti odluku o razrješenju u roku od 10 dana od primitka prijedloga. \r\n2) Dužnost povjerljive osobe prestaje povlačenjem pisanog pristanka za imenovanje, kao i prestankom radnog odnosa kod Poslodavca. \r\n3) Postupak za imenovanje druge povjerljive osobe pokreće se u roku od 30 dana od donošenja odluke o razrješenju ili prestanka dužnosti povjerljive osobe iz drugog razloga. \r\n4) Do imenovanja druge povjerljive osobe, poslove povjerljive osobe obavlja njezin zamjenik, osim ako okolnosti upućuju na potrebu za imenovanjem treće osobe da privremeno obavlja poslove povjerljive osobe.',
            },
        ],
    },
    {
        title: 'IV. OBVEZE POVJERLJIVE OSOBE',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Povjerljiva osoba prati primjenu zakona kojim se uređuje zaštita prijavitelja nepravilnosti te promiče poštivanje zakonskih rješenja i zaštitu prijavitelja nepravilnosti, zaprima prijave nepravilnosti, poduzima radnje iz svoje nadležnosti potrebne za zaštitu prijavitelja nepravilnosti, poduzima radnje radi ispitivanja nepravilnosti, prosljeđuje prijavu o nepravilnosti tijelima ovlaštenima na postupanje ovisno o sadržaju prijave, ako nepravilnost nije riješena s poslodavcem, pisanim putem obavještava podnositelja prijave o postupanju po prijavi, pruža informacije o postupcima za podnošenje prijave nadležnom tijelu za vanjsko prijavljivanje, kao i nadležnim institucijama, tijelima, uredima ili agencijama Europske unije nadležnim za postupanje po sadržaju prijave, štiti identitet i podatke iz prijave, pruža prijavitelju nepravilnosti opće informacije o njegovim pravima i postupku, omogućuje uvid u spis predmeta te vodi evidenciju o zaprimljenim prijavama. \r\n2) Povjerljiva osoba dužna je sudjelovati u programima edukacije koji se odnose na zaštitu prijavitelja nepravilnosti.',
            },
        ],
    },
    {
        title: 'V. POSTUPAK UNUTARNJEG PRIJAVLJIVANJA NEPRAVILNOSTI',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Unutarnje prijavljivanje nepravilnosti je prijavljivanje nepravilnosti Poslodavcu. ',
            },
        ],
    },
    {
        title: '',
        mandatory: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Prijavitelj nepravilnosti prijavu zakonom propisanog sadržaja može podnijeti pisanim ili usmenim putem. Pisana prijava se podnosi bilo kojim putem koji omogućava pisani zapis, uključujući elektroničkom poštom na adresu ___________________ kojoj će adresi imati pristup samo povjerljiva osoba. Usmeno prijavljivanje je moguće telefonom ili drugim sustavom glasovnih poruka te na zahtjev prijavitelja fizičkim sastankom u razumnom roku. \r\n2) Povjerljiva osoba dužna je obavijestiti prijavitelja nepravilnosti o potrebi i načinu dopune prijave, o njegovim pravima u postupku prijave nepravilnosti, o mogućnosti izravnog prijavljivanja tijelu nadležnom za vanjsko prijavljivanje, kao i o mogućnosti da se uočene nepravilnosti prijave i drugim nadležnim tijelima ovlaštenim za postupanje prema posebnim zakonima. \r\n3) Povjerljiva osoba će pisanim putem potvrditi privitak prijave u roku od sedam dana od njenog podnošenja.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Povjerljiva osoba dužna je: \r\n1. zaprimiti prijavu nepravilnosti i potvrditi primitak prijave u roku od sedam dana od dana primitka, \r\n2. bez odgode poduzeti radnje iz svoje nadležnosti potrebne za zaštitu prijavitelja nepravilnosti, \r\n3. poduzeti radnje radi ispitivanja nepravilnosti i dostaviti prijavitelju povratnu informaciju o prijavi u pravilu u roku od 30 dana, ali ne duljem od 90 dana od dana potvrde o primitku prijave ili ako potvrda nije poslana prijavitelju, nakon proteka sedam dana od dana podnošenja prijave, \r\n4. bez odgode prijavu o nepravilnosti proslijediti tijelima ovlaštenim na postupanje prema sadržaju prijave, ako nepravilnost nije riješena s Poslodavcem, \r\n5. bez odgode pisanim putem obavijestiti prijavitelja nepravilnosti o ishodu ispitivanja prijave, \r\n6. pisanim putem izvijestiti nadležno tijelo za vanjsko prijavljivanje nepravilnosti o zaprimljenim prijavama i ishodu postupanja u roku od 30 dana od dana odlučivanja o prijavi, \r\n7. čuvati identitet prijavitelja nepravilnosti i podatke zaprimljene u prijavi od neovlaštenog otkrivanja odnosno objave drugim osobama, osim ako to nije suprotno posebnom zakonu, \r\n8. pružiti jasne i lako dostupne informacije o postupcima za podnošenje prijave nadležnom tijelu za vanjsko prijavljivanje i, prema potrebi, institucijama, tijelima, uredima ili agencijama Europske unije nadležnim za postupanje po sadržaju prijave nepravilnosti. ',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Poslodavac ne smije utjecati ili pokušati utjecati na postupanje povjerljive osobe i njezina zamjenika prilikom poduzimanja radnji iz njihove nadležnosti potrebnih za zaštitu prijavitelja nepravilnosti.',
            },
        ],
    },
    {
        title: '',
        mandatory: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Povodom svake zaprimljene prijave nepravilnosti, povjerljiva osoba osniva predmet. \r\n2) Spis predmeta po podnesenoj prijavi sadrži najmanje: podatke o prijavitelju, opis nepravilnosti, informacije o osobi ili tijelu na koju se nepravilnost odnosi, datum primitka prijave, odnosno datum uočavanja nepravilnosti i prikupljenu dokumentaciju tijeka postupka. \r\n3) Povjerljiva osoba vodi očevidnik predmeta iz kojeg je vidljiv tijek postupka po zaprimljenim prijavama.',
            },
        ],
    },
    {
        title: '',
        mandatory: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Ako prijava nema zakonom propisani sadržaj, prijavitelj nepravilnosti poziva se na dopunu, odnosno ispravak prijave. \r\n2) U slučaju da prijavitelj nepravilnosti ne postupi prema pozivu iz stavka 1. ovog članka, prijava se neće smatrati prijavom nepravilnosti u smislu Zakona o zaštiti prijavitelja nepravilnosti, te će se podnositelja uputiti da nepravilnost može prijaviti tijelima ili osobama nadležnim prema sadržaju prijave u skladu s posebnim propisima',
            },
        ],
    },
    {
        title: '',
        mandatory: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Uz prethodni dogovor s prijaviteljem nepravilnosti, povjerljiva osoba po potrebi dostavlja podatke o prijavljenoj nepravilnosti Poslodavcu radi eventualnog pisanog očitovanja na navode iz prijave. \r\n2) Ako iz očitovanja prikupljenih u skladu s ovim Pravilnikom i Zakonom proizlazi da nepravilnost ne postoji, obavijest o tome dostavlja se prijavitelju nepravilnosti uz informaciju da prijavu može dostaviti i pučkoj pravobranitelju. \r\n3) Podaci iz stavka 1. ovog članka dostavljaju se uz uputu o dostavi povratne informacije u zatraženom roku i uz uputu o dužnosti zaštite povjerljivosti podataka iz prijave. ',
            },
        ],
    },
    {
        title: '',
        mandatory: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Ako se nakon provedbe postupka utvrdi da postoji nepravilnost, povjerljiva osoba o tome obavještava Poslodavca bez odgode u svrhu poduzimanja mjera za otklanjanje nepravilnosti. \r\n2) Povjerljivu osobu obavijestit će se o predviđenim i poduzetim mjerama za otklanjanje nepravilnosti u svrhu obavještavanja prijavitelja nepravilnosti.',
            },
        ],
    },
    {
        title: '',
        mandatory: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Ako povjerljiva osoba na temelju podataka iz prijave smatra da se ne radi o nepravilnosti sukladno Zakonu o zaštiti prijavitelja nepravilnosti, po prijavi neće postupati te će o tome bez odlaganja obavijestiti podnositelja prijave.                ',
            },
        ],
    },
    {
        title: '',
        mandatory: true,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Ako povjerljiva osoba smatra da prijavitelj nepravilnosti zbog podnesene prijave trpi osvetu dužna o tome obavijestiti Poslodavca kako bi se zaustavila osveta i otklonile njene posljedice. Povjerljiva osoba će Poslodavca obavijestiti i o zakonskim odredbama o zaštiti prijavitelja nepravilnosti.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) U svrhu provedbe ovog Pravilnika i Zakona o zaštiti prijavitelja nepravilnosti povjerljivoj osobi osiguravaju se potrebna sredstva te materijalni uvjeti za postupanje s dokumentacijom. ',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Na temelju zaprimljenih prijava i podataka iz spisa predmeta, povjerljiva osoba sastavlja godišnje izvješće o prijavljenim nepravilnostima kod Poslodavca. ',
            },
        ],
    },
  
  
    
    {
        title: 'VI. EVIDENCIJA PRIJAVA NEPRAVILNOSTI',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Poslodavac je dužan osigurati uvjete za vođenje evidencije o prijavama, sukladno odredbama Zakona. \r\n2) Povjerljive osobe vode evidenciju o svakoj zaprimljenoj prijavi nepravilnosti, u skladu sa zahtjevima u pogledu povjerljivosti predviđenima Zakonom.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Na obradu osobnih podataka sadržanih u prijavi nepravilnosti primjenjuju se propisi kojima se uređuje zaštita osobnih podataka. \r\n2) Povjerljiva osoba dužna je prije početka obavljanja poslova zaštite prijavitelja nepravilnosti potpisati Izjavu o povjerljivosti koja se prilaže očevidniku radnika. \r\n3) Podacima iz prijave nepravilnosti može pristupiti samo povjerljiva osoba. \r\n4) Dokumentacija vezana za postupak po prijavama nepravilnosti pohranjuje se u prostore za pohranu osigurane od neovlaštenog pristupa. \r\n5) Povjerljiva osoba dužna je i po prestanku obavljanja dužnosti povjerljive osobe, pa i nakon prestanka radnog odnosa kod Poslodavca čuvati povjerljivost podataka za koje je doznala tijekom obavljanja poslova povjerljive osobe. \r\n6) Osobni podaci sadržani u dokumentaciji iz postupka prijave nepravilnosti čuvaju se najduže 5 godina od zaprimanja prijave nepravilnosti, odnosno do okončanja sudskog postupka za zaštitu prijavitelja nepravilnosti. ',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Prijave se čuvaju u trajnom obliku sukladno nacionalnom pravu kojim je regulirana zaštita i obrada dokumentacije.  \r\n2) Ako se za podnošenje prijave upotrebljava telefonski uređaj na kojem je moguće napraviti zvučni zapis ili drugi sustav glasovnih poruka na kojem je moguće napraviti zvučni zapis, povjerljive osobe i tijelo nadležno za vanjsko prijavljivanje imaju pravo evidentirati usmenu prijavu, uz suglasnost prijavitelja, na jedan od sljedećih načina: zvučnim zapisom razgovora u trajnom i dostupnom obliku ili potpunim i točnim prijepisom razgovora koji izrađuju djelatnici koji su odgovorni za postupanje s prijavom. \r\n3)  Ako se za podnošenje prijave upotrebljava telefonski uređaj na kojem nije moguće napraviti zvučni zapis ili drugi sustav glasovnih poruka na kojem nije moguće napraviti zvučni zapis, povjerljiva osoba i tijelo nadležno za vanjsko prijavljivanje imaju pravo evidentirati usmenu prijavu u obliku točnog zapisa razgovora koji zapisuje djelatnik odgovoran za postupanje s prijavom. \r\n4) Ako osoba zatraži sastanak s povjerljivom osobom  za vanjsko prijavljivanje u svrhu podnošenja prijava, povjerljiva osoba osigurava, uz suglasnost prijavitelja, vođenje potpune i točne evidencije sa sastanka u trajnom i dostupnom obliku, na jedan od sljedećih načina: zvučnim zapisom razgovora u trajnom i dostupnom obliku ili točnim zapisnikom sa sastanka koji izrađuju djelatnici odgovorni za postupanje s prijavom. \r\n5) Povjerljiva osoba ponudit će prijavitelju mogućnost: provjere i ispravka prijepisa razgovora putem telefonskog poziva (čl. 18. st. 3. Zakona), provjere i ispravka zapisnika točnog prijepisa razgovora (čl. 18. st. 4. Zakona) i zapisnika sa sastanka između prijavitelja i povjerljive osobe (čl. 18. st. 6. Zakona), kao i mogućnost potvrde točnosti potpisom ',
            },
        ],
    },
    {
        title: 'VII. PRIJELAZNE I ZAVRŠNE ODREDBE ',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Ovaj Pravilnik stupa na snagu i primjenjuje se nakon proteka roka od 8 dana od dana objave na oglasnoj ploči Poslodavca. ',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Stupanjem na snagu ovog Pravilnika prestaje važiti eventualno doneseni raniji pravilnik o načinu imenovanja povjerljive osobe i postupku unutarnjeg prijavljivanja nepravilnosti. ',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Poslodavac je odredbe ovog Pravilnika dužan učiniti dostupnim svim osobama u radnom okruženju. \r\n2) Svi radnici su dužni surađivati s povjerljivom osobom u postupku ispitivanja nepravilnosti.',
            },
        ],
    },
    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: '1) Na pitanja koja nisu uređena ovim Pravilnikom, neposredno će se primijeniti odredbe Zakona o zaštiti prijavitelja nepravilnosti.',
            },
        ],
    },
    {
        mandatory: true,
        static: true,
        type: 2, // date and place
        statements: [
            {
                type: 'input',
                mandatory: true,
                parts: [
                    {
                        type: 'text',
                        content: 'U'
                    },
                    {
                        type: 'input',
                        value: '',
                        placeholder: "Upišite mjesto",
                        required: true
                    },
                    {
                        type: 'text',
                        content: ', dana'
                    },
                    {
                        type: 'date',
                        value: new Date(),
                        required: true
                    },
                    {
                        type: 'text',
                        content: 'godine.',
                    }
                ]
            },
        ]
    },
    {
        mandatory: true,
        static: true,
        type: 3,  // signatures
        statements: [],
    },
    {
        static: true,
        mandatory: false,
        type: 4, 
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Obavijest:\r\n1) Oglasna ploča Poslodavca \r\n2) Arhiva',
                
            }
        ]
    },
],
};

// staro  

// sides: [
//     {
//         prefix: "Na temelju Zakona o zaštiti prijavitelja nepravilnosti, ",
//         signature: 'Za Poslodavca',
//         inputs: [{
//             type: "input",
//             required: true,
//             placeholder: "Poslodavac",
//           },
//           {
//             type: "input",
//             required: true,
//             placeholder: "Ulica i kućni broj",
//           },
//           {
//             type: "input",
//             required: true,
//             placeholder: "Mjesto",
//           },
//           {
//             type: "input",
//             required: true,
//             placeholder: "OIB",
//           },
//           {
//             type: "input",
//             placeholder: "Zastupa",
//             inSignature: true,
//           },
//           {
//             type: "input",
//             placeholder: "Funkcija",
//             inSignature: true,
//           }],
//         suffix: ' (u daljnjem tekstu: Poslodavac),',
//     }
// ],

// headline: '​donosi sljedeći',
// title: 'PRAVILNIK O POSTUPKU UNUTARNJEG PRIJAVLJIVANJA NEPRAVILNOSTI I IMENOVANJA POVJERLJIVE OSOBE TE ZAMJENIKA POVJERLJIVE OSOBE',

// articles: [
    
//     {
//         title: 'I. TEMELJNE ODREDBE',
//         mandatory: true,
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: '1) Ovim Pravilnikom uređuje se postupak imenovanja povjerljive osobe i zamjenika povjerljive osobe te postupak unutarnjeg prijavljivanja nepravilnosti kod Poslodavca, a sukladno odredbama Zakona o zaštiti prijavitelja nepravilnosti (u daljnjem tekstu: Zakon).',
//             },
//         ],
//     },
//     {
//         title: '',
//         mandatory: false,
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: '1) Nepravilnost su radnje ili propusti koji su protupravni i odnose se na područje primjene i propise navedene u Zakona odnosno Prilozima Zakona ili su u suprotnosti s ciljem ili svrhom tih propisa. \r\n2) Prijavitelj nepravilnosti je fizička osoba koja prijavljuje ili javno razotkriva nepravilnosti o kojima je saznala u svom radnom okruženju.  \r\n3) Radno okruženje su profesionalne aktivnosti u javnom ili privatnom sektoru u okviru kojih, neovisno o prirodi tih aktivnosti, osobe stječu informacije o nepravilnostima i u okviru kojih bi te osobe mogle doživjeti osvetu ako prijave takve nepravilnosti, uključivši situaciju kada je aktivnost u međuvremenu prestala ili neposredno treba ili je trebala započeti, pri čemu takve aktivnosti posebno uključuju: a) osobe u radnom odnosu, b) osobe koje imaju položaj samozaposlenih osoba, c) imatelje dionica i poslovnih udjela, kao i osobe koje su članovi upravnog, upravljačkog ili nadzornog tijela trgovačkog društva, uključujući neizvršne članove, te volontere i plaćene ili neplaćene vježbenike, d) osobe koje rade pod nadzorom i u skladu s uputama ugovaratelja, podugovaratelja i dobavljača, e) osobe koje na bilo koji način sudjeluju u djelatnostima pravne ili fizičke osobe \r\n4) Prijavljena osoba je tijelo javne vlasti, fizička ili pravna osoba koja je u prijavi ili pri javnom razotkrivanju nepravilnosti navedena kao odgovorna za počinjenje nepravilnosti ili s njom povezana osoba. ',
//             },
//         ],
//     },
//     {
//         title: 'II. POSTUPAK IMENOVANJA POVJERLJIVE OSOBE I ZAMJENIKA POVJERLJIVE OSOBE',
//         mandatory: true,
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: '1) Povjerljiva osoba je fizička osoba zaposlena kod poslodavca ili treća fizička osoba imenovana od strane poslodavca radi zaprimanja prijava nepravilnosti, komunikacije s prijaviteljem i vođenja postupka zaštite u vezi s prijavom nepravilnosti ',
//             },
//         ],
//     },
//     {
//         title: '',
//         mandatory: true,
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: '1) Poslodavac je dužan imenovati povjerljivu osobu i zamjenika povjerljive osobe, za unutarnje prijavljivanje nepravilnosti, a prema odredbama ovog Pravilnika i Zakona. \r\n2) Poslodavac će imenovati povjerljivu osobu za unutarnje prijavljivanje nepravilnosti na prijedlog radničkog vijeća ili sindikalnog povjerenika koji je preuzeo prava i obveze radničkog vijeća, a ako radničko vijeće ili sindikalni povjerenik koji je preuzeo prava i obveze radničkog vijeća nisu ustanovljeni pri Poslodavcu, na prijedlog najmanje 20% radnika zaposlenih kod Poslodavca.  \r\n3) U slučaju više prijedloga radnika, prednost će imati prijedlog koji ima veću podršku radnika, a u slučaju prijedloga koji imaju jednaku podršku radnika, prednost će imati prijedlog koji je prvi zaprimljen.  \r\n4) Ako takvi prijedlozi nisu dani, Poslodavac će imenovati povjerljivu osobu i njezina zamjenika bez prijedloga radničkog vijeća ili sindikalnog povjerenika koji je preuzeo prava i obveze radničkog vijeća odnosno bez prijedloga najmanje 20% radnika zaposlenih kod Poslodavca.  ',
//             },
//         ],
//     },
//     {
//         title: '',
//         mandatory: false,
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: '1) Povjerljiva osoba i njezin zamjenik moraju dati pisanu suglasnost za imenovanje.',
//             },
//         ],
//     },
//     {
//         title: '',
//         mandatory: false,
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: '1) Povjerljiva osoba i/ili njezin zamjenik dužni su svoje dužnosti obavljati zakonito i savjesno te ne smiju zlouporabiti svoje ovlasti na štetu prijavitelja nepravilnosti. \r\n2) Povjerljiva osoba te njezin zamjenik imaju pravo na zaštitu identiteta i povjerljivosti te sudsku zaštitu ako učine vjerojatnim da je prema njima počinjena ili pokušana osveta, ili im se prijetilo osvetom zbog zaprimanja prijave o nepravilnosti odnosno postupanja po zaprimljenoj prijavi.    ',
//             },
//         ],
//     },
//     {
//         title: 'III. POSTUPAK RAZRJEŠENJA POVJERLJIVE OSOBE I ZAMJENIKA POVJERLJIVE OSOBE',
//         mandatory: true,
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: '1) Imenovanu povjerljivu osobu i njezina zamjenika Poslodavac će razriješiti bez odgađanja na temelju prijedloga radničkog vijeća ili sindikalnog povjerenika koji je preuzeo prava i obveze radničkog vijeća odnosno najmanje 20% radnika zaposlenih kod Poslodavca.',
//             },
//         ],
//     },
//     {
//         title: '',
//         mandatory: false,
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: '1) Poslodavac će pokrenuti postupak za imenovanje povjerljive osobe i njezina zamjenika najkasnije u roku od 30 dana od razrješenja povjerljive osobe i njezina zamjenika.\r\n2) Do donošenja odluke o imenovanju nove povjerljive osobe, poslove povjerljive osobe obavlja njezin zamjenik, osim ako okolnosti upućuju na to da je potrebno imenovati treću osobu da privremeno obavlja poslove povjerljive osobe. ',
//             },
//         ],
//     },
//     {
//         title: 'IV. VRSTE POSTUPAKA PRIJAVA NEPRAVILNOSTI',
//         mandatory: true,
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: '1) Prijavljivanje nepravilnosti može biti: \r\n- unutarnje (prijavljivanje nepravilnosti Poslodavcu), \r\n- vanjsko (prijavljivanje nepravilnosti nadležnom tijelu – pučkom pravobranitelju), \r\n- javno razotkrivanje (otkrivanje nepravilnosti javnosti). ',
//             },
//         ],
//     },
//     {
//         title: '',
//         mandatory: false,
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: '1) Unutarnje prijavljivanje nepravilnosti je prijavljivanje nepravilnosti Poslodavcu. ',
//             },
//         ],
//     },
//     {
//         title: 'V. PODNOŠENJE PRIJAVE I POSTUPAK PO PRIJAVI NEPRAVILNOSTI',
//         mandatory: true,
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: '1) Postupak unutarnjeg prijavljivanja nepravilnosti započinje dostavljanjem prijave povjerljivoj osobi. \r\n2) Prijava ili prijaviti je usmeno ili pisano prenošenje informacija o nepravilnostima.  \r\n3) Prijava nepravilnosti sadrži podatke o prijavitelju nepravilnosti, prijavljenom tijelu ili osobi te informacije o nepravilnostima.                ',
//             },
//         ],
//     },
//     {
//         title: '',
//         mandatory: false,
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: '1) Prijava nepravilnosti može se podnijeti u pisanom ili usmenom obliku. \r\n2) Pisani oblik uključuje svaki oblik komunikacije koji osigurava pisani zapis. Usmeno prijavljivanje moguće je telefonom ili drugim sustavima glasovnih poruka te, na zahtjev prijavitelja, fizičkim sastankom u razumnom roku.',
//             },
//         ],
//     },
//     {
//         title: '',
//         mandatory: false,
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: '1) Povjerljiva osoba dužna je: \r\n1. zaprimiti prijavu nepravilnosti i potvrditi primitak prijave u roku od sedam dana od dana primitka, \r\n2. bez odgode poduzeti radnje iz svoje nadležnosti potrebne za zaštitu prijavitelja nepravilnosti, \r\n3. poduzeti radnje radi ispitivanja nepravilnosti i dostaviti prijavitelju povratnu informaciju o prijavi u pravilu u roku od 30 dana, ali ne duljem od 90 dana od dana potvrde o primitku prijave ili ako potvrda nije poslana prijavitelju, nakon proteka sedam dana od dana podnošenja prijave, \r\n4. bez odgode prijavu o nepravilnosti proslijediti tijelima ovlaštenim na postupanje prema sadržaju prijave, ako nepravilnost nije riješena s Poslodavcem, \r\n5. bez odgode pisanim putem obavijestiti prijavitelja nepravilnosti o ishodu ispitivanja prijave, \r\n6. pisanim putem izvijestiti nadležno tijelo za vanjsko prijavljivanje nepravilnosti o zaprimljenim prijavama i ishodu postupanja u roku od 30 dana od dana odlučivanja o prijavi, \r\n7. čuvati identitet prijavitelja nepravilnosti i podatke zaprimljene u prijavi od neovlaštenog otkrivanja odnosno objave drugim osobama, osim ako to nije suprotno posebnom zakonu, \r\n8. pružiti jasne i lako dostupne informacije o postupcima za podnošenje prijave nadležnom tijelu za vanjsko prijavljivanje i, prema potrebi, institucijama, tijelima, uredima ili agencijama Europske unije nadležnim za postupanje po sadržaju prijave nepravilnosti. ',
//             },
//         ],
//     },
//     {
//         title: '',
//         mandatory: false,
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: '1) Poslodavac ne smije utjecati ili pokušati utjecati na postupanje povjerljive osobe i njezina zamjenika prilikom poduzimanja radnji iz njihove nadležnosti potrebnih za zaštitu prijavitelja nepravilnosti.',
//             },
//         ],
//     },
//     {
//         title: '',
//         mandatory: false,
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: '1) Povjerljiva osoba i njezin zamjenik moraju svoje dužnosti obavljati zakonito i savjesno i ne smiju zlouporabiti svoje ovlasti na štetu prijavitelja nepravilnosti.',
//             },
//         ],
//     },
//     {
//         title: '',
//         mandatory: false,
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: '1) Ako je prijavu nepravilnosti kod Poslodavca zaprimila osoba koja nije nadležna za postupanje po prijavi nepravilnosti, ista ju je dužna bez odgode i bez izmjena proslijediti povjerljivoj osobi uz zaštitu identiteta prijavitelja nepravilnosti i povjerljivosti podataka iz prijave.',
//             },
//         ],
//     },
//     {
//         title: 'VI. EVIDENCIJA PRIJAVA NEPRAVILNOSTI',
//         mandatory: false,
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: '1) Poslodavac je dužan osigurati uvjete za vođenje evidencije o prijavama, sukladno odredbama Zakona. \r\n2) Povjerljive osobe vode evidenciju o svakoj zaprimljenoj prijavi nepravilnosti, u skladu sa zahtjevima u pogledu povjerljivosti predviđenima Zakonom.',
//             },
//         ],
//     },
//     {
//         title: '',
//         mandatory: false,
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: '1) Prijave se čuvaju u trajnom obliku sukladno nacionalnom pravu kojim je regulirana zaštita i obrada dokumentacije.  \r\n2) Ako se za podnošenje prijave upotrebljava telefonski uređaj na kojem je moguće napraviti zvučni zapis ili drugi sustav glasovnih poruka na kojem je moguće napraviti zvučni zapis, povjerljive osobe i tijelo nadležno za vanjsko prijavljivanje imaju pravo evidentirati usmenu prijavu, uz suglasnost prijavitelja, na jedan od sljedećih načina: zvučnim zapisom razgovora u trajnom i dostupnom obliku ili potpunim i točnim prijepisom razgovora koji izrađuju djelatnici koji su odgovorni za postupanje s prijavom. \r\n3)  Ako se za podnošenje prijave upotrebljava telefonski uređaj na kojem nije moguće napraviti zvučni zapis ili drugi sustav glasovnih poruka na kojem nije moguće napraviti zvučni zapis, povjerljiva osoba i tijelo nadležno za vanjsko prijavljivanje imaju pravo evidentirati usmenu prijavu u obliku točnog zapisa razgovora koji zapisuje djelatnik odgovoran za postupanje s prijavom. \r\n4) Ako osoba zatraži sastanak s povjerljivom osobom  za vanjsko prijavljivanje u svrhu podnošenja prijava, povjerljiva osoba osigurava, uz suglasnost prijavitelja, vođenje potpune i točne evidencije sa sastanka u trajnom i dostupnom obliku, na jedan od sljedećih načina: zvučnim zapisom razgovora u trajnom i dostupnom obliku ili točnim zapisnikom sa sastanka koji izrađuju djelatnici odgovorni za postupanje s prijavom. \r\n5) Povjerljiva osoba ponudit će prijavitelju mogućnost: provjere i ispravka prijepisa razgovora putem telefonskog poziva (čl. 18. st. 3. Zakona), provjere i ispravka zapisnika točnog prijepisa razgovora (čl. 18. st. 4. Zakona) i zapisnika sa sastanka između prijavitelja i povjerljive osobe((čl. 18. st. 6. Zakona), kao i mogućnost potvrde točnosti potpisom ',
//             },
//         ],
//     },
//     {
//         title: 'VII. PRIJELAZNE I ZAVRŠNE ODREDBE ',
//         mandatory: false,
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: '1) Ovaj Pravilnik stupa na snagu i primjenjuje se nakon proteka roka od 8 dana od dana objave na oglasnoj ploči Poslodavca. ',
//             },
//         ],
//     },
//     {
//         title: '',
//         mandatory: false,
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: '1) Poslodavac je odredbe ovog Pravilnika dužan učiniti dostupnim svim osobama u radnom okruženju.',
//             },
//         ],
//     },
//     {
//         title: '',
//         mandatory: false,
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: '1) Na pitanja koja nisu uređena ovim Pravilnikom, neposredno će se primijeniti odredbe Zakona o zaštiti prijavitelja nepravilnosti.',
//             },
//         ],
//     },
//     {
//         mandatory: true,
//         static: true,
//         type: 2, // date and place
//         statements: [
//             {
//                 type: 'input',
//                 mandatory: true,
//                 parts: [
//                     {
//                         type: 'text',
//                         content: 'U'
//                     },
//                     {
//                         type: 'input',
//                         value: '',
//                         placeholder: "Upišite mjesto",
//                         required: true
//                     },
//                     {
//                         type: 'text',
//                         content: ', dana'
//                     },
//                     {
//                         type: 'date',
//                         value: new Date(),
//                         required: true
//                     },
//                     {
//                         type: 'text',
//                         content: 'godine.',
//                     }
//                 ]
//             },
//         ]
//     },
//     {
//         mandatory: true,
//         static: true,
//         type: 3,  // signatures
//         statements: [],
//     },
//     {
//         static: true,
//         mandatory: false,
//         type: 4, 
//         statements: [
//             {
//                 type: 'text',
//                 mandatory: true,
//                 editable: true,
//                 content: 'Obavijest:\r\n1) Oglasna ploča Poslodavca \r\n2) Arhiva',
                
//             }
//         ]
//     },
// ],
// };






// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/220.1_pravilnik_zvizdaci.ts